// extracted by mini-css-extract-plugin
module.exports = {"splash-css":"Splash_splash-css_UkLp2","imageSplash":"Splash_imageSplash_1OhN9","mymove":"Splash_mymove_2iyK5","paddB":"Splash_paddB_3aHdZ"};